import { InitOptions } from 'i18next';

export const OPTIONS: InitOptions = {
    resources: {
        en: {
            translation: {
                administrator: 'Administrator',
                mainOffice: 'Central Office',
                address: 'Vlorë, Sarandë, Skënderbeu Street, Building n.3, Floor n.3, Door n.4',
                mainPage: 'Home',
                contactsHeader: 'Contact & Quotations',
                jobsHeader: 'Work With Us',
                companyDescription: 'Construction & Services',
                companyMoto: 'Quality & Reliability without compromises.',
                companySince: 'Since 1997.',
                send: 'Send',
                services: {
                    title: 'Services, Equipment & more',
                    paving: 'Road paving, in house production at all stages',
                    plants: 'Asphalt & Bituminous Emulsion production plants',
                    signs: 'Vertical and Horizontal traffic signs',
                    maintenance: 'Road maintenance',
                    constructions: 'Civil and Industrial constructions and reconstruction',
                    tools: 'Full range of construction vehicles and tools',
                    certifications: 'Certified for all provided services'
                },
                eco: {
                    title: 'Ecological & Environmental Services',
                    cleaning: 'Sewer and Drain Cleaning Services',
                    vehicles: 'Intervetions with a fleet of different size machines for every use case',
                    oils: 'Boat waste and oil treatment & discharge',
                    maintenance: 'Sewer pipe treatment and maintenance for Institutions and Condominiums',
                    sanitation: 'Sanification, disinfestation',
                    waste: 'Inert waste collection'
                },
                contact: {
                    title: 'Information or job quotations? Connect with',
                    description: 'Choose a category and send a request. You will be contacted soon.',
                    number: 'Contact number',
                    info: 'Information',
                    quotation: 'Work quotation',
                    renting: 'Vehicle and tool rental',
                    eco: 'Sewer blockages, interventions and discharge',
                    other: 'Other',
                    details: 'Details',
                    error: 'Something went wrong. For more help contact ',
                    success: 'Message sent. You will be contacted soon.'
                },
                jobs: {
                    title: 'Experienced and a specialist at your craft? Tell us more!',
                    description: 'From technicians to specialists in various fields, we are continuously expanding and looking for skilled people. Make sure to enter a contact number and briefly describe your skills and experiences.',
                    aboutYou: 'About you'
                }
            }
        },
        it: {
            translation: {
                administrator: 'Amministratore',
                mainOffice: 'Sede Centrale',
                address: 'Vlorë, Sarandë, Via Skënderbeu, Edificio n.3, Piano n.3, Porta n.4',
                mainPage: 'Home',
                contactsHeader: 'Contatti & Preventivi',
                jobsHeader: 'Lavora Con Noi',
                companyDescription: 'Construction & Services',
                companyMoto: 'Qualità & Affidabilità senza compromessi.',
                companySince: 'Dal 1997.',
                send: 'Invia',
                services: {
                    title: 'Servizi, Attrezzatura & altro',
                    paving: 'Pavimentazione stradale, con produzione interna di tutti i componenti',
                    plants: 'Impianti per la produzione di Emulsioni Bituminose & Asfalto',
                    signs: 'Segnaletica stradale Verticale e Orizzontale',
                    maintenance: 'Manutenzione strade',
                    constructions: 'Costruzioni civili e industriali',
                    tools: 'Flotta completa di veicoli e strumenti per l\'edilizia',
                    certifications: 'Certificazioni per tutti i servizi forniti'
                },
                eco: {
                    title: 'Servizi Ecologici e Ambientali',
                    cleaning: 'Autospurgo pozzi neri e sturamenti impianti idrici e fognanti',
                    vehicles: 'Interventi con una flotta di macchine di vari dimensioni',
                    oils: 'Trattamento e scarico dei rifiuti e l\'olio delle barce',
                    maintenance: 'Manutenzione dei condotti fognari per enti e condomini',
                    sanitation: 'Sanificazione e disinfestazione',
                    waste: 'Ritiro rifiuti inerti'
                },
                contact: {
                    title: 'Informazioni o preventivi di lavoro? Connettiti con',
                    description: 'Scegli una categoria e invia una richiesta. Sarai contattato al più presto.',
                    number: 'Numero di contatto',
                    info: 'Informazioni',
                    quotation: 'Preventivo di lavori',
                    renting: 'Noleggio autoveicoli e strumenti',
                    eco: 'Trattamento, sblocco e scarico acque reflue',
                    other: 'Altro',
                    details: 'Dettagli',
                    error: 'Qualcosa è andato storto. Per aiuto contatta ',
                    success: 'Messaggio inviato. Verrai contattato al più presto.'
                },
                jobs: {
                    title: 'Sei un specialista nel tuo mestiere? Parlaci di più!',
                    description: 'Da tecnici a specialisti in vari campi, siamo in espansione continua e alla ricerca di persone qualificate. Assicurati di inserire un numero di contatto e di descrivere brevemente le tue capacità ed esperienze.',
                    aboutYou: 'Raccontaci di più'
                }
            }
        },
        al: {
            translation: {
                administrator: 'Administrator',
                mainOffice: 'Zyra Qëndrore',
                address: 'Vlorë, Sarandë, Lagjja Nr.1, Rruga Skënderbeu, Godina nr.3, Kati i 3, Hyrja Nr.4',
                mainPage: 'Faqja Kryesore',
                contactsHeader: 'Kontakt & Preventive',
                jobsHeader: 'Puno Me Ne',
                companyDescription: 'Construction & Services',
                companyMoto: 'Cilësi dhe Siguri pa kompromise.',
                companySince: 'Që prej 1997.',
                send: 'Dergo',
                services: {
                    title: 'Shërbime, Pajisje & më shumë',
                    paving: 'Asfaltim rrugësh, prodhim i të gjithë komponentëve të nevojshëm në çdo fazë',
                    plants: 'Fabrikë për prodhim Asfalti dhe Emulsion Bituminoz',
                    signs: 'Sinjalistikë rrugore Vertikale dhe Horizontale',
                    maintenance: 'Mirëmbajtje rrugësh',
                    constructions: 'Rikonstruksione dhe ndërtime civile e industriale',
                    tools: 'Flotë e kompletuar makinerish, mjetesh dhe pajisjesh',
                    certifications: 'Të certifikuar për të gjitha shërbimet e ofruara'
                },
                eco: {
                    title: 'Shërbime Ekologjike dhe Mjedisore',
                    cleaning: 'Pastrim dhe zhbllokim kanalizimesh te ujërave te zeza',
                    vehicles: 'Ndërhyrje me një flotë makinash të përmasave të ndryshme për çdo situatë',
                    oils: 'Trajtim dhe shkarkim i ujërave të zeza dhe vajrave nga jahte dhe anije',
                    maintenance: 'Mirëmbajtje e kanalizimeve për institucione',
                    sanitation: 'Sanifikim dhe dezinfektim ambientesh',
                    waste: 'Mbledhje mbetjesh inerte'
                },
                contact: {
                    title: 'Informacion apo preventiv punimesh? Lidhu me',
                    description: 'Zgjidh një nga kategoritë më poshtë dhe dërgo një kërkesë. Do të kontaktohesh së shpejti.',
                    number: 'Numër kontakti',
                    info: 'Informacion',
                    quotation: 'Preventiv punimesh',
                    renting: 'Automjete dhe pajisje me qera',
                    eco: 'Pastrim, zhbllokim dhe shkarkim i ujërave të zeza',
                    other: 'Tjetër',
                    details: 'Detaje',
                    error: 'Aktualisht e pamundur të dërgohet mesazhi. Për ndihmë kontakto ',
                    success: 'Mesazhi u dërgua. Do të kontaktohesh së shpejti.'
                },
                jobs: {
                    title: 'Specialist punimesh në fushën tënde? Na thuaj më shumë!',
                    description: 'Nga teknik të lartë te specialist të fushëve të ndryshme, jemi gjithmonë duke u zgjeruar dhe kërkuar njerëz të aftë. Sigurohu të vendosësh një numër kontakti dhe përshkruaj shkurtimisht aftësitë dhe eksperiencat e tua.',
                    aboutYou: 'Dy fjalë rreth teje'
                }
            }
        }
    },
    lng: 'al',
    fallbackLng: 'al',
    interpolation: {
        escapeValue: false // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    }
}
